// extracted by mini-css-extract-plugin
export default {"hero-slide":"HeroSlide_hero-slide__f9FIg"};